module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Bold.bce77fc7.otf";